import { TLocalizedString } from "../../pipes/localized/localized.interface";
import { ICarbonFootPrint } from "libraries/component/carbon-footprint/carbon-footprint.interface";
import { IQuoteLuggage } from "libraries/service/resources/airTrip/IGetAirTripQuotes";

export interface IQuote {
    booking: IBookings;
    dictionary: {
        aircraft: IAircraft;
        airport: IAirports;
    };
    key: string;
    quantity: {
        booking: number;
    };
    status: {
        severity: string;
    };
}

export interface IAirports {
    [key: string]: IAirport;
}

export interface IAirport {
    airport: {
        code: string;
        name: string;
    };
    city: {
        code: string;
        name: string;
    };
    country: {
        code: string;
        name: string;
    };
}

export interface ICarrier {
    [key: string]: {
        code: string;
        name: string;
    };
}

export interface IAircraft {
    [key: string]: {
        code: string;
        name: string;
    };
}

export interface IBookings {
    [key: string]: IBooking;
}

export interface IBooking {
    details: IDetails[];
    fareType: string;
    luggage?: IQuoteLuggage;
    luggageArray?: IQuoteLuggage[];
    priceDifference: number;
    segment: ISegments;
    total: string;
    totals: ITotals[];
    traveller: any; // Aucune information
    type: string;
    validity: {
        end: string;
    };
    value: number;
    vender: string;
    transactionId: string;
}

export interface ISegments {
    [key: string]: ISegment;
}

export interface ITotals {
    target: string;
    role: "Base" | "Tax" | "Total";
    total: number;
    traveller: string[];
}

export interface ISegment {
    (key: string): ISegmentInformation;
    journey: string[];
    seat?: string[];
    xId?: string;
}

export interface ISegmentInformation {
    begin: string;
    carrier: Array<{ code: string; name?: string }>;
    duration: {
        minutes: number;
    };
    durationStop: {
        minutes: number;
    };
    end: string;
    from: string;
    sector: ISector[];
    stop: string;
    to: string;
    via: string[];
    rating?: IAirRating;
}

export interface IAirRating {
    value: number;
    displayedValue?: number;
    max: number;
    displayedMax?: number;
    average?: number;
    distributor: EAirRatingDistributor;
    detailArray?: IAirRatingDetail[];
    name?: TLocalizedString;
    description?: TLocalizedString;
}

export enum EAirRatingDistributor {
    yucangoo = 'yucangoo',
    afidium = 'afidium',
}

export enum EAirRatingDetailNames {
    carbonFootprint = 'carbonFootprint',
    punctuality = 'punctuality',
    routing = 'routing',
    topCarrier = 'topCarrier',
    relationship = 'relationship',
}

export interface IAirRatingDetail {
    value: number;
    displayedValue?: number;
    max: number;
    displayedMax?: number;
    code: EAirRatingDetailNames;
    carrier?: Array<{ code: string }>;
    stops?: number;
    carbonFootPrint?: ICarbonFootPrint;
}

export interface ISector {
    aircraft?: string;
    begin: string;
    carrier: {
        code: string;
    };
    duration: {
        minutes: number;
    };
    durationStop?: {
        minutes: number;
    };
    end: string;
    flight: string;
    from: string | IAirport;
    seat?: {
        [key: string]: {
            max?: number;
            status?: string;
            xCabin?: string;
        };
    };
    to: string | IAirport;
}


export interface IRule {
    calculation: ICalculation[];
    in: string;
    restriction: IRestriction[];
    segment: string[];
    traveller: string[];
}

export interface IRestriction {
    max: string;
    unit: string;
    topic: string;
}

export interface ICalculation {
    for: string;
    unit: string;
}

export interface IDetails {
    target: string;
    role: string;
    quantity: string;
    value: number;
    total: number;
    traveller: string[];
}

export interface ISectorLight {
    xId: string;
}

export interface ITraveller extends ISectorLight {
    xType: 'adult' | 'child' | 'infant';
}

export interface IPermission {
    booking: { 
        create: boolean,
        saveOffer: boolean
    };
    searchForm: { use: boolean };
}
